import { ModuleApprovalsRedirect } from '@/modules/approvals/ModuleApprovalsRedirect';

/** @deprecated Use global inbox at /work/approvals */
export function ProcurementApprovalsPage() {
  return <ModuleApprovalsRedirect ownerModule="PROCUREMENT" />;
}
